module.exports = __webpack_public_path__ + "img/result-moon.9f30adcc.png";